export default "__VITE_ASSET__b8dac109__"